import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import "../../static/style/wp-content.css";

class FourOhFour extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-sm-12">
          <h1>
            <FormattedMessage
              id="app.error.404.title"
              defaultMessage="Sivua ei löytynyt"
            />
          </h1>
          <p>
            <FormattedMessage
              id="app.error.404.description"
              defaultMessage="Etsimääsi sivua ei löytynyt."
            />
          </p>
        </div>
      </div>
    );
  }
}

export default FourOhFour;



// WEBPACK FOOTER //
// ./src/containers/static/FourOhFour.js